import { getApi } from '../api/storeFront';
import { parseStoreCategory, getListOfSubHierarchy, getFilteredCollection } from '../utils';
const getCategories = async ({ count, cursor, filter }, logger) => {
    const urlParams = new URLSearchParams();
    urlParams.append('count', count.toString());
    urlParams.append('cursor', cursor.toString());
    const response = await getApi(`/collections?${urlParams.toString()}`, logger);
    const menuResonseJson = await getApi(`/classification?handle=${filter}`, logger);
    const hierarchy = getListOfSubHierarchy(menuResonseJson.data.items);
    const categories = getFilteredCollection(hierarchy, response?.data);
    return {
        data: [...parseStoreCategory(categories)],
        paginate() {
            return (!!response.hasNextPage &&
                getCategories({
                    count,
                    cursor: response?.cursor,
                    filter,
                }, logger));
        },
    };
};
export default getCategories;
